import { TbCheck } from "react-icons/tb";
import { TRANSFER_WIZARD_STEPS } from "../constants";

export const ContaInternacionalTransferStepper = ({ currentStep = 0 }) => (
  <nav aria-label="Etapas da transferência internacional" className="mb-4 w-full">
    <ol className="flex w-full items-center">
      {TRANSFER_WIZARD_STEPS.map((step, index) => {
        const allCompleted = currentStep >= TRANSFER_WIZARD_STEPS.length;
        const isCompleted = allCompleted || index < currentStep;
        const isActive = !allCompleted && index === currentStep;
        const isLast = index === TRANSFER_WIZARD_STEPS.length - 1;

        return (
          <li key={step.id} className={`flex items-center ${isLast ? "" : "flex-1"}`}>
            <div className="flex min-w-[3.5rem] flex-col items-center gap-1">
              <div
                className={`flex h-7 w-7 items-center justify-center rounded-full text-[11px] font-bold transition ${
                  isCompleted
                    ? "bg-[#e7a73f] text-white"
                    : isActive
                      ? "border-2 border-[#e7a73f] bg-white text-[#a66f1d]"
                      : "border border-gray-200 bg-white text-gray-400"
                }`}
              >
                {isCompleted ? <TbCheck className="h-3.5 w-3.5" /> : index + 1}
              </div>
              <span
                className={`hidden text-center text-[10px] font-semibold sm:block ${
                  isActive || isCompleted ? "text-brand-dark" : "text-gray-400"
                }`}
              >
                {step.label}
              </span>
            </div>
            {!isLast && (
              <div
                className={`mx-1.5 h-0.5 flex-1 rounded-full ${
                  isCompleted ? "bg-[#e7a73f]" : "bg-gray-200"
                }`}
              />
            )}
          </li>
        );
      })}
    </ol>
  </nav>
);
